import React from 'react'
 

export default function about() {
    return ( 
        <React.Fragment>
              
        <section className="resume-section" id="about">
        <div className="resume-section-content">
            <h1 className="mb-0">Deepanshu <span className="text-primary">Ahuja</span></h1>
            <div className="subheading mb-5">DL/139 ·  New Colony, Palwal ,HRY (121102) · +91 7206969076 · <a href="mailto:deepanshu2912@gmail.com">deepanshu2912@gmail.com</a></div>
            <p className="lead mb-5">Seeking for a Software Developer position in a fast growing organization to utilize expertise in software development and testing, as well as deployment and support using agile development methodologies. Coming with well honed skills in computer science in addition to excellent communication skills.</p>
            <div className="social-icons"> 
                <a className="social-icon" href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                <a className="social-icon" href="https://www.github.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
                <a className="social-icon" href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a className="social-icon"href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            </div>
        </div>
    </section>
     <hr className="m-0" />
   </React.Fragment>
    )
}
